import { PARTNER_ID } from 'src/config'
import { tokenSelector } from 'src/state/authentication/selectors'
import store from 'src/state/store'
import { unauthenticatedError } from './CommonMiddlewares'
import { ExtendedData, Http } from './Http'

const lexonHttp = new Http()

export function tokenMiddleware(data: ExtendedData): Promise<ExtendedData> {
  const token = tokenSelector(store.getState())
  data.headers = data.headers || {}
  data.headers['Content-type'] = data.headers['Content-type'] || 'application/json'
  data.headers.Accept = data.headers.Accept || 'application/json'
  data.headers['LEXON-PARTNER-ID'] = PARTNER_ID
  data.headers.Authorization = `Bearer ${token}`
  return Promise.resolve(data)
}

lexonHttp.addMidleware('onRequest', tokenMiddleware)
lexonHttp.addMidleware('onError', unauthenticatedError)

export default lexonHttp
